import { render, staticRenderFns } from "./realNameSaveInfo.vue?vue&type=template&id=bb7258c6&scoped=true&"
import script from "./realNameSaveInfo.vue?vue&type=script&lang=js&"
export * from "./realNameSaveInfo.vue?vue&type=script&lang=js&"
import style0 from "./realNameSaveInfo.vue?vue&type=style&index=0&id=bb7258c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7258c6",
  null
  
)

export default component.exports